module.exports = __webpack_public_path__ + "static/media/campsite-area-add.fc6d6b48.svg";